import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";
import { fetchIntroSettings } from "./introNavigation";


const GameTuto = ({ gameId, language, customUrl}) => {
  const { t, i18n } = useTranslation();
  // Réglages relus depuis la config de la partie : prioritaires sur les paramètres d'URL,
  // qui peuvent manquer (lien partagé, reprise d'atelier)
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    fetchIntroSettings(gameId)
      .then(setSettings)
      .catch((error) => {
        console.error("Error fetching intro settings:", error);
        setSettings({});
      });
  }, [gameId]);

  const activeLanguage = settings?.language || language;
  const videoUrl = settings?.tuto_url || customUrl || t("tuto-video-link");

  useEffect(() => {
    if (activeLanguage) {
      i18n.changeLanguage(activeLanguage);
    }
  }, [activeLanguage, i18n]);

  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleNextClick = async () => {
    setLoading(true);
    navigate("/game/" + gameId);
    setLoading(false);
  };

  return loading || settings === null ? (
    <div className="loader-container">
      <img src="/loader.gif" className="loader" />
    </div>
  ) : (
    <Fragment>
      <div className="text-intro-title">{t("Déroulement de l'atelier")}</div>
      <div className="tuto-video">
        <iframe
          width="560"
          height="315"
          src={videoUrl}
          // src="https://www.youtube.com/embed/e_ZhIm8_oCE?si=VnGFeecy8C3sxCDg"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
        ></iframe>
      </div>

      <div className="next-intro-section">
        <button class="blue-button" onClick={handleNextClick}>
          {t("Commencer le jeu")}
        </button>
      </div>
    </Fragment>
  );
};

export default GameTuto;
